module.exports = __webpack_public_path__ + "static/media/sourcesanspro-bold-webfont.738b5fd5.woff";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/source-sans-pro/sourcesanspro-bold-webfont.woff
// module id = 501
// module chunks = 0